/**
 * The shared field appearance.
 *
 * <select> and <textarea> cannot render through TextInput, but they must
 * still look identical to it - before this, each spelled the class string
 * out again and several had drifted (a missing focus:ring-2, so the focus
 * ring rendered a different width on some controls than others).
 */
export const FIELD_BASE =
  "w-full rounded-md border px-3 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-biafit-primary dark:bg-navy-700 dark:text-white dark:[color-scheme:dark]";

export const FIELD_BORDER =
  "border-gray-300 focus:border-biafit-primary dark:border-gray-600";

export const FIELD_INVALID =
  "border-red-500 focus:border-red-500 focus:ring-red-500";

/**
 * Muted text for a <select> whose value is still the placeholder option, so
 * "Select fitness level" reads as a prompt rather than a chosen value.
 * Pass as `extra`: fieldClass(invalid, value ? "" : FIELD_PLACEHOLDER).
 */
export const FIELD_PLACEHOLDER = "text-gray-400 dark:text-gray-500";

/** The full class string for a textarea, or an input TextInput cannot render. */
export const fieldClass = (invalid = false, extra = "") =>
  `${FIELD_BASE} ${invalid ? FIELD_INVALID : FIELD_BORDER} ${extra}`.trim();

/**
 * What turns the shared field into a <select>. Safari ignores the padding on
 * a select that keeps its native chrome, so it renders shorter than the
 * inputs beside it; drawing the chevron ourselves makes every browser lay it
 * out exactly like TextInput.
 */
export const FIELD_SELECT =
  "appearance-none bg-white bg-select-chevron bg-[length:1.25rem_1.25rem] bg-[position:right_0.75rem_center] bg-no-repeat pr-10";

/** The full class string for a select. */
export const selectClass = (invalid = false, extra = "") =>
  fieldClass(invalid, `${FIELD_SELECT} ${extra}`.trim());
